// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.img-wrap[data-v-5cd9692d]{\n    display: flex;\n    align-items: center;\n    flex-flow: wrap;\n    margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
